// Copyright 2023 LiveKit, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.10.1 with parameter "target=dts+js"
// @generated from file livekit_cloud_agent.proto (package livekit, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum livekit.AgentSecretKind
 */
export const AgentSecretKind = /*@__PURE__*/ proto3.makeEnum(
  "livekit.AgentSecretKind",
  [
    {no: 0, name: "AGENT_SECRET_KIND_UNKNOWN", localName: "UNKNOWN"},
    {no: 1, name: "AGENT_SECRET_KIND_ENVIRONMENT", localName: "ENVIRONMENT"},
    {no: 2, name: "AGENT_SECRET_KIND_FILE", localName: "FILE"},
  ],
);

/**
 * @generated from enum livekit.AgentEventType
 */
export const AgentEventType = /*@__PURE__*/ proto3.makeEnum(
  "livekit.AgentEventType",
  [
    {no: 0, name: "AGENT_EVENT_TYPE_UNKNOWN", localName: "UNKNOWN"},
    {no: 1, name: "AGENT_EVENT_TYPE_APPLICATION_CRASHED", localName: "APPLICATION_CRASHED"},
    {no: 2, name: "AGENT_EVENT_TYPE_RESTARTED_HIGH_DISK_USAGE", localName: "RESTARTED_HIGH_DISK_USAGE"},
    {no: 3, name: "AGENT_EVENT_TYPE_RESTARTED_HIGH_MEMORY_USAGE", localName: "RESTARTED_HIGH_MEMORY_USAGE"},
  ],
);

/**
 * @generated from message livekit.AgentEvent
 */
export const AgentEvent = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.AgentEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AgentEventType) },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.AgentSecret
 */
export const AgentSecret = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.AgentSecret",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "updated_at", kind: "message", T: Timestamp },
    { no: 5, name: "kind", kind: "enum", T: proto3.getEnumType(AgentSecretKind) },
    { no: 6, name: "deployments", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message livekit.CreateAgentRequest
 */
export const CreateAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreateAgentRequest",
  () => [
    { no: 1, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 3, name: "replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "max_replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "cpu_req", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message livekit.CreateAgentResponse
 */
export const CreateAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreateAgentResponse",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "presigned_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "server_regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "presigned_post_request", kind: "message", T: PresignedPostRequest },
  ],
);

/**
 * @generated from message livekit.CreateAgentV2Request
 */
export const CreateAgentV2Request = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreateAgentV2Request",
  () => [
    { no: 1, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 2, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message livekit.CreateAgentV2Response
 */
export const CreateAgentV2Response = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreateAgentV2Response",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "server_regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message livekit.PromoteAgentRequest
 */
export const PromoteAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PromoteAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src_deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dst_deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.PromoteAgentResponse
 */
export const PromoteAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PromoteAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "src_deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "dst_deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "version_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.PresignedPostRequest
 */
export const PresignedPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PresignedPostRequest",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "values", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message livekit.AgentDeployment
 */
export const AgentDeployment = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.AgentDeployment",
  () => [
    { no: 1, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "min_replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "max_replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "cpu_req", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "cur_cpu", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "cur_mem", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "mem_req", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "mem_limit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "cpu_limit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "server_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "events", kind: "message", T: AgentEvent, repeated: true },
    { no: 15, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "deployment_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "last_scraped_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.AgentInfo
 */
export const AgentInfo = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.AgentInfo",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "agent_deployments", kind: "message", T: AgentDeployment, repeated: true },
    { no: 5, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 6, name: "deployed_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.ListAgentsRequest
 */
export const ListAgentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentsRequest",
  () => [
    { no: 1, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.ListAgentsResponse
 */
export const ListAgentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentsResponse",
  () => [
    { no: 1, name: "agents", kind: "message", T: AgentInfo, repeated: true },
  ],
);

/**
 * @generated from message livekit.AgentVersion
 */
export const AgentVersion = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.AgentVersion",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "current", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "deployed_at", kind: "message", T: Timestamp },
    { no: 5, name: "attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "draining", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message livekit.ListAgentVersionsRequest
 */
export const ListAgentVersionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentVersionsRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.ListAgentVersionsResponse
 */
export const ListAgentVersionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentVersionsResponse",
  () => [
    { no: 1, name: "versions", kind: "message", T: AgentVersion, repeated: true },
  ],
);

/**
 * @generated from message livekit.UpdateAgentRequest
 */
export const UpdateAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.UpdateAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "max_replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "cpu_req", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "regions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
  ],
);

/**
 * @generated from message livekit.UpdateAgentResponse
 */
export const UpdateAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.UpdateAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.RestartAgentRequest
 */
export const RestartAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.RestartAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.RestartAgentResponse
 */
export const RestartAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.RestartAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.DeployAgentRequest
 */
export const DeployAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeployAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 4, name: "replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "max_replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "cpu_req", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message livekit.DeployAgentResponse
 */
export const DeployAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeployAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "presigned_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "presigned_post_request", kind: "message", T: PresignedPostRequest },
    { no: 7, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.DeployAgentV2Request
 */
export const DeployAgentV2Request = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeployAgentV2Request",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 3, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message livekit.DeployAgentV2Response
 */
export const DeployAgentV2Response = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeployAgentV2Response",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "presigned_req", kind: "message", T: PresignedPostRequest },
    { no: 6, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.UpdateAgentSecretsRequest
 */
export const UpdateAgentSecretsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.UpdateAgentSecretsRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "overwrite", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
    { no: 5, name: "remove", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message livekit.UpdateAgentSecretsResponse
 */
export const UpdateAgentSecretsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.UpdateAgentSecretsResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.RollbackAgentRequest
 */
export const RollbackAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.RollbackAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.RollbackAgentResponse
 */
export const RollbackAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.RollbackAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.DeleteAgentRequest
 */
export const DeleteAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeleteAgentRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deployment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.DeleteAgentResponse
 */
export const DeleteAgentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DeleteAgentResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.ListAgentSecretsRequest
 */
export const ListAgentSecretsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentSecretsRequest",
  () => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.ListAgentSecretsResponse
 */
export const ListAgentSecretsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListAgentSecretsResponse",
  () => [
    { no: 1, name: "secrets", kind: "message", T: AgentSecret, repeated: true },
  ],
);

/**
 * @generated from message livekit.SettingsParam
 */
export const SettingsParam = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.SettingsParam",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.ClientSettingsResponse
 */
export const ClientSettingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ClientSettingsResponse",
  () => [
    { no: 1, name: "params", kind: "message", T: SettingsParam, repeated: true },
  ],
);

/**
 * @generated from message livekit.ClientSettingsRequest
 */
export const ClientSettingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ClientSettingsRequest",
  [],
);

/**
 * @generated from message livekit.PrivateLink
 */
export const PrivateLink = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PrivateLink",
  () => [
    { no: 1, name: "private_link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "port", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "connection_endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "cloud_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "aws", kind: "message", T: PrivateLink_AWSConfig, oneof: "config" },
  ],
);

/**
 * @generated from message livekit.PrivateLink.AWSConfig
 */
export const PrivateLink_AWSConfig = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PrivateLink.AWSConfig",
  () => [
    { no: 1, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PrivateLink_AWSConfig"},
);

/**
 * @generated from message livekit.PrivateLinkStatus
 */
export const PrivateLinkStatus = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.PrivateLinkStatus",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(PrivateLinkStatus_Status) },
    { no: 2, name: "updated_at", kind: "message", T: Timestamp },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum livekit.PrivateLinkStatus.Status
 */
export const PrivateLinkStatus_Status = /*@__PURE__*/ proto3.makeEnum(
  "livekit.PrivateLinkStatus.Status",
  [
    {no: 0, name: "PRIVATE_LINK_STATUS_UNKNOWN"},
    {no: 1, name: "PRIVATE_LINK_STATUS_PROVISIONING"},
    {no: 2, name: "PRIVATE_LINK_STATUS_PENDING_APPROVAL"},
    {no: 3, name: "PRIVATE_LINK_STATUS_HEALTHY"},
    {no: 4, name: "PRIVATE_LINK_STATUS_UNHEALTHY"},
    {no: 5, name: "PRIVATE_LINK_STATUS_APPROVED"},
  ],
);

/**
 * @generated from message livekit.CreatePrivateLinkRequest
 */
export const CreatePrivateLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreatePrivateLinkRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "port", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "cloud_region", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "aws", kind: "message", T: CreatePrivateLinkRequest_AWSCreateConfig, oneof: "config" },
  ],
);

/**
 * @generated from message livekit.CreatePrivateLinkRequest.AWSCreateConfig
 */
export const CreatePrivateLinkRequest_AWSCreateConfig = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreatePrivateLinkRequest.AWSCreateConfig",
  () => [
    { no: 1, name: "endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreatePrivateLinkRequest_AWSCreateConfig"},
);

/**
 * @generated from message livekit.CreatePrivateLinkResponse
 */
export const CreatePrivateLinkResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.CreatePrivateLinkResponse",
  () => [
    { no: 1, name: "private_link", kind: "message", T: PrivateLink },
  ],
);

/**
 * @generated from message livekit.DestroyPrivateLinkRequest
 */
export const DestroyPrivateLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DestroyPrivateLinkRequest",
  () => [
    { no: 1, name: "private_link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.DestroyPrivateLinkResponse
 */
export const DestroyPrivateLinkResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.DestroyPrivateLinkResponse",
  [],
);

/**
 * @generated from message livekit.ListPrivateLinksRequest
 */
export const ListPrivateLinksRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListPrivateLinksRequest",
  [],
);

/**
 * @generated from message livekit.ListPrivateLinksResponse
 */
export const ListPrivateLinksResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ListPrivateLinksResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: PrivateLink, repeated: true },
  ],
);

/**
 * @generated from message livekit.GetPrivateLinkStatusRequest
 */
export const GetPrivateLinkStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.GetPrivateLinkStatusRequest",
  () => [
    { no: 1, name: "private_link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message livekit.GetPrivateLinkStatusResponse
 */
export const GetPrivateLinkStatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.GetPrivateLinkStatusResponse",
  () => [
    { no: 1, name: "value", kind: "message", T: PrivateLinkStatus },
  ],
);

